import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export interface WarehouseStockQuery {
  page: number;
  pageSize: number;
  warehouse_id: string;        // <-- ONLY NEW FIELD
  search?: string;
  sort?: string;
  order?: "asc" | "desc" | "";
  filters?: any;
}

export const fetchWarehouseWiseStock = createAsyncThunk(
  "inventory/warehouseStockOverview",
  async (query: WarehouseStockQuery, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      params.append("page", String(query.page));
      params.append("pageSize", String(query.pageSize));

      // NEW: warehouse_id added
      if (query.warehouse_id) params.append("warehouse_id", query.warehouse_id);

      // Search
      if (query.search) params.append("search", query.search);

      // Sorting (same logic you already use)
      if (query.sort) {
        const orderingValue =
          query.order === "desc" ? `-${query.sort}` : query.sort;
        params.append("ordering", orderingValue);
      }

      // Filters (same as your existing logic)
      if (Array.isArray(query.filters)) {
        query.filters.forEach((f: any) => {
          if (f.filterField && f.filterValue !== undefined) {
            params.append(f.filterField, f.filterValue);
          }
        });
      }

      // FINAL API CALL (same as your in-stock)
      const response = await Axios.get(`/inventory/in-stock`, { params });
      const api = response.data;

      return {
        data: api.data || [],
        totalRecords: api.count || 0,
        page: query.page,
        pageSize: query.pageSize,
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);
